import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PolicyModule } from '../../appshared/webTools/policy/policy.module';
import { PolicyService } from '../../appshared/webTools/policy/policy.service';

@Component({
  selector: 'app-tawtheeq-policy',
  templateUrl: './tawtheeq-policy.component.html',
  styleUrls: ['./tawtheeq-policy.component.scss']
})
export class TawtheeqPolicyComponent implements OnInit {
  public policyFiles: PolicyModule[];
  constructor(
    public service: PolicyService,
    public translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.getAllService();
  }

  getAllService() {
    this.policyFiles = this.service.getService();
  }


  downloadFile(url: string) {
    const link = document.createElement('a');
    link.href = url;
    link.download = url.split('/').pop() || 'download.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

}
